import { Component, OnInit } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { User } from '@app/core/_models'
import { BookSessionsService, FeatureCheckService } from '@app/core/_services'
import { AnalyticsService } from '@app/core/_services/analytics.service'
import { PlayToneService } from '@app/core/_services/play-tone.service'
import { UserService } from '@app/core/_services/user.service'
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { faStar } from '@fortawesome/pro-regular-svg-icons'
import { faArrowLeft, faTimes, faVideo, faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import { Subject, take } from 'rxjs'

const MODAL_NAME = 'Focus Now - Release'

@Component({
    selector: 'fm-feature-release-modal',
    templateUrl: './feature-release-modal.component.html',
    styleUrls: ['./feature-release-modal.component.scss'],
    standalone: false,
})
export class FeatureReleaseModalComponent implements OnInit {
    faTimes = faTimes
    faStar = faStar
    faVideo = faVideo
    faUpRightFromSquare = faUpRightFromSquare
    faArrowLeft = faArrowLeft
    faArrowRight = faArrowRight

    private currentUser: User = new User()
    public showHowItWorks: boolean = false

    public joinSessionClickedSubject = new Subject<void>()

    constructor(
        private analyticsService: AnalyticsService,
        public userService: UserService,
        public dialog: MatDialogRef<FeatureReleaseModalComponent>,
        private bookSessionService: BookSessionsService,
        private playToneService: PlayToneService,
        private featureCheckService: FeatureCheckService,
    ) {}

    ngOnInit(): void {
        this.userService.currentUser.pipe(take(1)).subscribe((user) => {
            this.currentUser = user
        })
        this.analyticsService.logViewedModalEvent(MODAL_NAME)
    }

    startNowSession(): void {
        this.playToneService.playEndSessionToneMuted()
        this.analyticsService.logClickedEvent('Start 50 min session', MODAL_NAME)
        this.bookSessionService.bookNowSessionClickedSubject.next()
        this.dialog.close()
    }

    learnMore() {
        this.analyticsService.logClickedEvent('Learn more', MODAL_NAME)
    }

    howItWorksClicked() {
        this.analyticsService.logClickedEvent('How does it work?', MODAL_NAME)
        this.showHowItWorks = true
    }

    onBackButtonClick() {
        this.showHowItWorks = false
    }

    ngOnDestroy(): void {
        if (this.currentUser.userId) {
            this.featureCheckService.setHasViewedLatestReleaseModal(this.currentUser)
        }
    }
}
